import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() headerType: string = 'logo';
  @Input() headerText: string = '';
  @Input() rightLink: string = '';
  @Output() goBack = new EventEmitter<string>();
  @Output() rightLinkAction = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}
}
